import { BRAND_ORANGE, brandSwitchStyles } from '../../../../styles/brandSwitchStyles';

export { BRAND_ORANGE, brandSwitchStyles };

export const FIELD_BORDER = 'divider';
export const PLACEHOLDER_COLOR = 'text.disabled';

export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: 'background.paper',
    fontSize: '0.875rem',
    '& fieldset': {
      borderColor: FIELD_BORDER,
    },
    '&:hover fieldset': {
      borderColor: 'text.disabled',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'primary.main',
      borderWidth: 1,
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: PLACEHOLDER_COLOR,
    opacity: 1,
  },
};

export const fieldErrorSx = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#d32f2f',
    },
    '&:hover fieldset': {
      borderColor: '#d32f2f',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#d32f2f',
    },
  },
};

export const mergeFieldSx = (hasError) => (hasError ? { ...fieldSx, ...fieldErrorSx } : fieldSx);

/** Fixed-height multiline fields: keep the initial row count and scroll overflow. */
export const multilineFieldSx = {
  ...fieldSx,
  '& .MuiOutlinedInput-root': {
    ...fieldSx['& .MuiOutlinedInput-root'],
    alignItems: 'flex-start',
  },
  '& textarea': {
    overflowY: 'auto !important',
    resize: 'none',
  },
};

export const mergeMultilineFieldSx = (hasError) =>
  hasError ? { ...multilineFieldSx, ...fieldErrorSx } : multilineFieldSx;

export const characterCountSx = {
  display: 'block',
  textAlign: 'right',
  mt: 0.5,
  fontSize: '0.75rem',
  color: PLACEHOLDER_COLOR,
  lineHeight: 1.2,
};
